{
  "dashboard": "Bảng điều khiển",
  "orders": "Đơn hàng",
  "csvVendorOverride": "Nhập CSV gán Vendor",
  "merchants": "Nhà bán hàng",
  "vendors": "Nhà cung cấp",
  "stores": "Cửa hàng",
  "orderList": "Danh sách đơn hàng",
  "orderSettings": "Cài đặt đơn hàng",
  "vendorMapping": "Định tuyến Vendor",
  "auditLog": "Nhật ký kiểm toán",
  "shipping": {
    "group": "Vận chuyển",
    "price": "Giá vận chuyển",
    "trackRouting": "Theo dõi định tuyến",
    "config": "Cấu hình",
    "rateTable": "Bảng giá rate",
    "rateTable2": "Rate Table 2",
    "rt2Routing": "Định tuyến",
    "rt2Margin": "Báo cáo lợi nhuận",
    "rt2History": "Lịch sử",
    "rt2Rate": "Bảng giá",
    "comingSoon": "Sắp ra mắt"
  },
  "billing": "Thanh toán",
  "settings": "Cài đặt",
  "groups": {
    "finance": "Tài chính",
    "billing": "Thanh toán",
    "products": "Blueprints",
    "pricing": "Bảng giá",
    "reports": "Báo cáo",
    "system": "Hệ thống",
    "support": "Hỗ trợ",
    "operations": "Vận hành",
    "salesCrm": "Kinh doanh / CRM",
    "affiliate": "Tiếp thị liên kết",
    "homeManagement": "Quản lý trang chủ",
    "monitoring": "Giám sát"
  },
  "finance": {
    "invoices": "Hóa đơn",
    "agingReport": "Báo cáo công nợ",
    "creditMemos": "Phiếu tín dụng",
    "refundTasks": "Hoàn tiền",
    "pendingApprovals": "Chờ duyệt",
    "paymentRequests": "Yêu cầu thanh toán",
    "transactions": "Giao dịch",
    "payouts": "Chi trả Vendor",
    "topupReviews": "Duyệt nạp tiền",
    "credits": "Tín dụng",
    "gateways": "Cổng thanh toán",
    "transferGroups": "Nhóm chuyển khoản",
    "legalEntities": "Pháp nhân",
    "topupQueue": "Hàng đợi nạp tiền",
    "withdrawQueue": "Rút tiền của Merchant",
    "chargebacks": "Chargeback (bồi hoàn)",
    "fraudSettings": "Cấu hình chống gian lận",
    "whitelist": "Whitelist",
    "imapConfig": "Cấu hình IMAP",
    "fxRates": "Tỷ giá hối đoái"
  },
  "products": {
    "categories": "Danh mục",
    "blueprints": "Bản thiết kế",
    "options": "Tuỳ chọn",
    "productApproval": "Duyệt sản phẩm",
    "productsSpecial": "Sản phẩm đặc biệt",
    "bundles": "Combo",
    "mapping": "Mapping",
    "collections": "Bộ sưu tập",
    "addOns": "Tùy chọn thêm",
    "pricing": "Giá",
    "techniques": "Kỹ thuật in",
    "templates": "Mẫu thiết kế",
    "root": "Sản phẩm",
    "materials": "Vật liệu",
    "regionErrors": "Lỗi vùng in",
    "checkTypes": "Loại kiểm tra",
    "printAreas": "Vùng in",
    "locations": "Vị trí"
  },
  "pricing": {
    "prices": "Giá",
    "pricesV2": "Giá V2",
    "blueprintCost": "Giá vốn bản thiết kế",
    "packingGroups": "Nhóm đóng gói",
    "pricingConfig": "Cấu hình giá"
  },
  "reports": {
    "analytics": "Phân tích",
    "orderWarnings": "Cảnh báo đơn hàng",
    "syncErrorReports": "Báo cáo lỗi đồng bộ",
    "auditLogs": "Nhật ký kiểm toán",
    "accountantActivity": "Hoạt động kế toán",
    "exportCenter": "Trung tâm xuất dữ liệu"
  },
  "system": {
    "users": "Người dùng",
    "roles": "Vai trò",
    "settings": "Cấu hình hệ thống",
    "announcements": "Thông báo",
    "dualApproval": "Hàng đợi duyệt kép",
    "emailTemplates": "Mẫu email",
    "rolesMatrix": "Vai trò & Quyền",
    "adminMgmt": "Quản lý Admin",
    "featureFlags": "Cờ tính năng",
    "health": "Tình trạng hệ thống",
    "maintenance": "Chế độ bảo trì",
    "bugTracker": "Theo dõi lỗi"
  },
  "support": {
    "dashboard": "Bảng hỗ trợ",
    "tickets": "Ticket",
    "departments": "Queue bộ phận",
    "inbox": "Hộp thư",
    "performance": "Hiệu suất",
    "configurations": "Cấu hình"
  },
  "assignSalesCs": "Gán Sale & CS",
  "navAria": "Điều hướng quản trị",
  "superAdminOnly": "Chỉ Super Admin",
  "operations": {
    "shipmentTracking": "Theo dõi vận chuyển",
    "pendingManualAssign": "Đơn chờ gán thủ công"
  },
  "sales": {
    "overview": "Tổng quan",
    "leads": "Leads",
    "deals": "Deal",
    "salerGroups": "Nhóm sale",
    "calendar": "Lịch",
    "targets": "Chỉ tiêu",
    "leaderboard": "Bảng xếp hạng",
    "gmvReport": "Báo cáo GMV",
    "operations": "Vận hành",
    "merchants": "Nhà bán hàng của Sale",
    "benefits": "Quyền lợi",
    "reports": "Báo cáo",
    "settings": "Cài đặt"
  },
  "affiliate": {
    "hub": "Trung tâm Affiliate",
    "list": "Danh sách Affiliate",
    "payoutQueue": "Hàng đợi chi trả",
    "shortLinks": "Liên kết rút gọn",
    "abuseReport": "Báo cáo lạm dụng"
  },
  "homeManagement": {
    "homepage": "Trang chủ",
    "ebooks": "Ebook",
    "blog": "Blog",
    "help": "Trung tâm trợ giúp",
    "stories": "Câu chuyện",
    "faq": "Câu hỏi thường gặp",
    "sellerSurvey": "Khảo sát người bán",
    "footer": "Chân trang",
    "contact": "Liên hệ",
    "pages": "Trang"
  },
  "inventory": {
    "overview": "Tổng quan kho",
    "group": "Kho hàng",
    "stockLevel": "Tồn kho theo mức",
    "valuation": "Định giá tồn kho",
    "movement": "Xuất nhập kho",
    "aging": "Tuổi tồn kho",
    "turnover": "Vòng quay tồn kho"
  },
  "monitoring": {
    "queueJobs": "Hàng đợi & Tác vụ",
    "webhookLogs": "Log Webhook",
    "syncErrors": "Lỗi đồng bộ",
    "imapParser": "Bộ phân tích IMAP"
  },
  "vendorsPending": "Chờ duyệt",
  "vendorsServices": "Dịch vụ vận chuyển"
}
